import { useEffect, useState } from "react";
import { Bell, Loader2, MessageCircle } from "lucide-react";
import api from "@/lib/api";
import { Sheet, SheetContent, SheetDescription, SheetHeader, SheetTitle } from "@/components/ui/sheet";
import { B, ago } from "./common";
import { Avatar } from "./PostCard";

const TXT = { like: "ti ha dato un gettone Vesta", comment: "ha commentato il tuo post", reply: "ha risposto a un post che segui" };
const name = (a) => (a.staff ? a.name : a.partner_name || a.name);

export default function Notifications({ open, onOpenChange, onOpenPost, onRead }) {
  const [list, setList] = useState(null);
  useEffect(() => {
    if (!open) return;
    setList(null);
    api.get(`${B}/notifiche`).then((r) => { setList(r.data); if (r.data.some((n) => !n.read)) api.post(`${B}/notifiche/read`).then(() => onRead?.()).catch(() => {}); }).catch(() => setList([]));
  }, [open, onRead]);
  return (
    <Sheet open={open} onOpenChange={onOpenChange}>
      <SheetContent className="flex w-full flex-col border-[#2A303C] bg-[#16191E] text-white sm:max-w-md" data-testid="bacheca-notif-sheet">
        <SheetHeader><SheetTitle className="flex items-center gap-2 font-heading text-white"><Bell className="h-5 w-5 text-[#C17F59]" />Notifiche</SheetTitle><SheetDescription className="sr-only">Attività sui tuoi post</SheetDescription></SheetHeader>
        <div className="-mx-2 min-h-0 flex-1 overflow-y-auto pt-3">
          {!list ? <Loader2 className="mx-2 h-5 w-5 animate-spin text-[#C17F59]" /> : list.map((n) => (
            <button key={n.id} type="button" onClick={() => onOpenPost(n.post_id)} data-testid={`bacheca-notif-${n.id}`}
              className={`flex w-full items-start gap-3 rounded-xl px-2 py-2.5 text-left transition-colors hover:bg-[#1F242D] ${n.read ? "" : "bg-[#C17F59]/10"}`}>
              <span className="relative">
                <Avatar a={n.actor} logo={n.actor_logo} foto={n.actor_foto} size={42} />
                <span className="absolute -bottom-1 -right-1 flex h-5 w-5 items-center justify-center rounded-full border-2 border-[#16191E] bg-[#1F242D]">
                  {n.tipo === "like" ? <img src="/vesta-coin-rame.png" alt="" className="h-4 w-4" /> : <MessageCircle className="h-3 w-3 text-[#38BDF8]" />}
                </span>
              </span>
              <span className="min-w-0 flex-1 text-sm leading-snug">
                <b className="font-semibold text-white">{name(n.actor)}</b> <span className="text-[#D1D5DB]">{TXT[n.tipo]}</span>
                {n.post_label && <span className="text-[#9CA3AF]">: «{n.post_label}»</span>}
                {n.testo && <span className="mt-0.5 line-clamp-2 block text-[13px] text-[#9CA3AF]">“{n.testo}”</span>}
                <span className="mt-0.5 block text-[11px] text-[#6B7280]">{ago(n.at)}</span>
              </span>
              {!n.read && <span className="mt-2 h-2 w-2 shrink-0 rounded-full bg-[#C17F59]" />}
            </button>
          ))}
          {list && list.length === 0 && <p className="px-2 text-sm text-[#6B7280]" data-testid="bacheca-notif-empty">Nessuna notifica. Quando qualcuno commenta o dà un gettone ai tuoi post lo vedrai qui.</p>}
        </div>
      </SheetContent>
    </Sheet>
  );
}
